import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { Hidden } from 'ui-components/common/Hidden';
import { Link } from 'ui-components/common/Link';
import { isPC } from 'constants/layout';

export interface SubMenuProps<K extends string> {
  className?: string;
  menuList: K[];
  menuPath: Record<K, string>;
  menuText: Record<K, string>;
  selectedMenu: K;
}

export const SubMenu = <K extends string>({
  className,
  menuList,
  menuPath,
  menuText,
  selectedMenu,
}: SubMenuProps<K>) => {
  const HiddenUl = Hidden.withComponent('ul');

  return (
    <>
      <HiddenUl>
        {menuList.map(menu => (
          <li key={menu}>
            <Link key={menu} href={menuPath[menu]}>
              {menuText[menu]}
            </Link>
          </li>
        ))}
      </HiddenUl>
      <StyledMenu className={className}>
        {menuList.map(menu => (
          <Link key={menu} href={menuPath[menu]}>
            <StyledContainer isSelected={selectedMenu === menu}>{menuText[menu]}</StyledContainer>
          </Link>
        ))}
      </StyledMenu>
    </>
  );
};

const StyledMenu = styled.section`
  display: flex;
  width: 100vw;
  gap: 32px;
  margin: auto;
  justify-content: left;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledContainer = styled.p(
  ({ isSelected }: { isSelected?: boolean }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    height: 100%;
    text-wrap: nowrap;

    color: ${isSelected ? Color.Black : 'initial'};
    font-weight: ${isSelected ? FontWeight.Bold : FontWeight.Regular};
    ${Typography.XXSmall};

    @media (${isPC}) {
      width: initial;
      padding: 10px 0;
    }
  `,
);
